import { render, staticRenderFns } from "./modal-kplh.vue?vue&type=template&id=30df3454&scoped=true&"
import script from "./modal-kplh.vue?vue&type=script&lang=js&"
export * from "./modal-kplh.vue?vue&type=script&lang=js&"
import style0 from "./modal-kplh.vue?vue&type=style&index=0&id=30df3454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30df3454",
  null
  
)

export default component.exports